"use client";

import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import Button from "components/common/button";
import SwiperWrapper from "components/swiper-wrapper";
import HighlighterListingProjectCard from "../../homepage/highlighter-card/project-card";

import styles from "./styles.module.css";

const ProjectDetailCompanyInfo = ({ companyDetail, companysProjects }) => {
  const projects = companysProjects?.projectCards?.records || [];

  const goToProfile = () => {
    setTimeout(() => {
      Ga4WithEventParameters({
        eventName: "proje-radari",
        event_parameters: {
          label: "click || proje-firma-profiline-git-BUTTON_TYPE",
          project_company_name: companyDetail?.name,
        },
      });
    }, 300);
  };

  return (
    <div className={styles.container}>
      <b className={styles.cardTitle}>Firma Künyesi</b>
      <div className={styles.wrapper}>
        <div className={styles.contentWrapper}>
          <div className={styles.companysCard}>
            <div className={styles.content}>
              <div className={styles.titleAndButton}>
                <div className={styles.titleAndLocation}>
                  <span className={styles.companyName}>{companyDetail?.name}</span>
                  <p
                    className={styles.companyLocation}
                  >{`${companyDetail?.city?.name}, ${companyDetail?.district?.name}`}</p>
                </div>
                <Button
                  href={`/projeler/firma/${companyDetail?.slug}/`}
                  buttonClass={styles.button}
                  onClick={goToProfile}
                >
                  Profile Git
                </Button>
              </div>
              <hr className={styles.line} />
              <div className={styles.companyPromotion} dangerouslySetInnerHTML={{ __html: companyDetail?.introText }} />
            </div>
          </div>
        </div>
        {projects.length > 1 && (
          <div className={styles.listWrap}>
            <div className={styles.topWrap}>
              <b className={styles.listTitle}>Firmanın Diğer Projeleri</b>
            </div>
            <SwiperWrapper>
              <Swiper navigation={true} loop={false} modules={[Navigation]} slidesPerView={3}>
                <ul>
                  {projects.map((project, index) => (
                    <SwiperSlide key={index}>
                      <ul>
                        <li>
                          <HighlighterListingProjectCard
                            key={index}
                            listItemInfo={project}
                            isCompanyDetail
                            isProjectDetail
                          />
                        </li>
                      </ul>
                    </SwiperSlide>
                  ))}
                </ul>
              </Swiper>
            </SwiperWrapper>
          </div>
        )}
      </div>
    </div>
  );
};

ProjectDetailCompanyInfo.propTypes = {
  companyDetail: PropTypes.object.isRequired,
  companysProjects: PropTypes.object.isRequired,
};

export default ProjectDetailCompanyInfo;
